'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTypicalResponseTimeMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isTypicalResponseTimeMessage = exports.isTypicalResponseTimeMessage = (0, _isType.isType)(_messageTypes.TYPICAL_RESPONSE_TIME);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isTypicalResponseTimeMessage.js
// module id = 220
// module chunks = 2 3